import React from 'react';

const Spinner = () => (
  <div className="full-screen-spinner ">
    <div className="spinner-border text-success" />
  </div>
);

export default Spinner;
